import { SMLRouteNames, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { SMLSectionTab } from '../components/SMLSectionTabs/SMLSectionTabs';
import { smlNavigationMessages, smlSectionTabMessages } from '../navigation/smlNavigationMessages';

/** The routes that are a tab of Pitch. */
export type PitchTabScreen =
  | SMLRouteNames.outreach
  | SMLRouteNames.outreachContacts
  | SMLRouteNames.outreachFind
  | SMLRouteNames.outreachCommunities;

/**
 * The tabs of Pitch (design navigation-v2 d 4a, 4d): Campaigns, Contacts, Find, Community spots.
 * Each tab is its old route. A Results tab comes with the all-songs results route (not built yet).
 */
export function pitchTabs(screen: SMLRouteNames | undefined): SMLSectionTab[] {
  return [
    {
      id: 'campaigns',
      label: smlSectionTabMessages.outreachCampaigns,
      route: SMLRoutes.outreach,
      active: screen === SMLRouteNames.outreach,
    },
    {
      id: 'contacts',
      label: smlNavigationMessages.outreachContacts,
      route: SMLRoutes.outreachContacts,
      active: screen === SMLRouteNames.outreachContacts,
    },
    {
      id: 'find',
      label: smlNavigationMessages.outreachFind,
      route: SMLRoutes.outreachFind,
      active: screen === SMLRouteNames.outreachFind,
    },
    {
      id: 'communities',
      label: smlNavigationMessages.outreachCommunities,
      route: SMLRoutes.outreachCommunities,
      active: screen === SMLRouteNames.outreachCommunities,
    },
  ];
}
